import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  DateField,
  FunctionField,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
} from 'react-admin';
import { ChipList, ListActions } from '../common';
import { EventPhoto } from './EventPhoto';

const eventFilters = [
  <TextInput key="id" source="id" label="ID" alwaysOn />,
  <ReferenceInput
    key="eventTypeId"
    source="eventTypeId"
    reference="event-types"
    label="Event Type"
    alwaysOn
  >
    <SelectInput optionText="name" />
  </ReferenceInput>,
  <ReferenceInput key="machineId" source="machineId" reference="machines" label="Machine" alwaysOn>
    <AutocompleteInput optionText="serial" />
  </ReferenceInput>,
];

export const EventList = () => {
  return (
    <List
      filters={eventFilters}
      sort={{ field: 'eventTime', order: 'DESC' }}
      actions={<ListActions />}
    >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="id" />
        <ReferenceField
          source="eventTypeId"
          reference="event-types"
          link={false}
          label="Event Type"
          sortBy="eventTypeId"
        >
          <FunctionField
            render={(record: { id: number; name: string }) => (
              <ChipList
                items={[
                  {
                    id: record.id,
                    label: record.name,
                    color: 'primary',
                  },
                ]}
              />
            )}
          />
        </ReferenceField>
        <ReferenceField
          source="machineId"
          reference="machines"
          link={false}
          label="Machine"
          sortBy="machineId"
        >
          <FunctionField
            render={(record: { id: number; serial: string }) =>
              record ? (
                <ChipList
                  items={[
                    {
                      id: record.id,
                      label: record.serial,
                      to: `/machines/${record.id}/show`,
                    },
                  ]}
                />
              ) : (
                <ChipList items={[]} emptyText="N/A" />
              )
            }
          />
        </ReferenceField>
        <ReferenceField
          source="printingId"
          reference="printings"
          link={false}
          label="Printing"
          sortBy="printingId"
        >
          <FunctionField
            render={(record: { id: number; uuid: string }) =>
              record ? (
                <ChipList
                  items={[
                    {
                      id: record.id,
                      label: record.id.toString(),
                      to: `/printings/${record.id}/show`,
                    },
                  ]}
                />
              ) : (
                <ChipList items={[]} emptyText="N/A" />
              )
            }
          />
        </ReferenceField>
        <DateField source="eventTime" showTime />
        <TextField source="error" emptyText="" />
        <FunctionField
          sortable={false}
          label="Photo"
          render={(record: { photoUrl: string | null }) => (
            <EventPhoto photoUrl={record.photoUrl} size="medium" />
          )}
        />
      </Datagrid>
    </List>
  );
};
